import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-m-4" }
const _hoisted_2 = { class: "p-d-flex p-flex-column p-m-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-arrow-right",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Chip = _resolveComponent("Chip")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "metaweb-inccorect-relationships-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.metawebInvalidRelationshipsDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false,
    baseZIndex: 10,
    autoZIndex: true
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.warning')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("h3", null, _toDisplayString(_ctx.$t('metaweb.incorrectRelationships.title')), 1),
        _createVNode("p", null, _toDisplayString(_ctx.$t('metaweb.incorrectRelationships.warningMessage.partOne')), 1),
        _createVNode("p", null, _toDisplayString(_ctx.$t('metaweb.incorrectRelationships.warningMessage.partTwo')), 1),
        _createVNode("p", null, _toDisplayString(_ctx.$t('metaweb.incorrectRelationships.warningMessage.partThree')), 1)
      ]),
      _createVNode("div", _hoisted_2, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.incorrectRelationships, (relation, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: "p-m-4"
          }, [
            _createVNode("h2", null, _toDisplayString(relation.businessRelationshipName), 1),
            _createVNode("div", null, [
              _createTextVNode(_toDisplayString(relation.sourceTableName) + " ", 1),
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(relation.destinationTableName), 1)
            ]),
            _createVNode(_component_Chip, { class: "p-m-2" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('metaweb.incorrectRelationships.requiredColumns') + ': ' + relation.requiredNumberOfColumns), 1)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}